import React from "react";
import CssClasses from "./BetTypeButton.css";

const BetTypeButton = props => {
  let classes = [CssClasses.button];

  // if (props.isActive) {
  //   classes.push(CssClasses.active);
  // }

  if (props.sportID) {
    //i dodaj boju ovisno o sportu
    switch (props.sportID) {
      case 1: // soccer
        classes.push(CssClasses.headerRowColorSoccer);
        break;
      case 2: //basketball
        classes.push(CssClasses.headerRowColorBasketball);
        break;
      case 3: //baseball
        classes.push(CssClasses.headerRowColorBaseball);
        break;
      case 4: //hockey
        classes.push(CssClasses.headerRowColorHockey);
        break;
      case 5: //tennis
        classes.push(CssClasses.headerRowColorTennis);
        break;
      case 6: //handball
        classes.push(CssClasses.headerRowColorHandball);
        break;
      case 12: //rugby
        classes.push(CssClasses.headerRowColorRugby);
        break;
      case 16: //Football
        classes.push(CssClasses.headerRowColorFootball);
        break;
      case 19: //Snooker
        classes.push(CssClasses.headerRowColorSnooker);
        break;
      case 20: //TableTennis
        classes.push(CssClasses.headerRowColorTableTennis);
        break;
      case 23: //volleyball
        classes.push(CssClasses.headerRowColorVolleyball);
        break;
      case 29: //futsal
        classes.push(CssClasses.headerRowColorFutsal);
        break;
      case 31: //Badminton
        classes.push(CssClasses.headerRowColorBadminton);
        break;
      default:
        break;
    }
  }

  if (props.isActive) {
    //resetiraj klase
    classes = [CssClasses.button];

    if (props.isLightTheme) {
      classes.push(CssClasses.lightThemeActive);
    } else {
      classes.push(CssClasses.active);
    }
  } else if (props.isLightTheme) {
    classes.push(CssClasses.lightTheme);
  }

  if (props.inLiveEventGroup) {
    classes.push(CssClasses.inLiveEventGroup);
  }

  return (
    <div
      onClick={() => {
        props.onButtonClicked(props.id);
      }}
      className={classes.join(" ")}
    >
      {/* <div
        className={[
          CssClasses.indicator,
          props.isActive ? CssClasses.activeIndicator : ""
        ].join(" ")}
      >
        &nbsp;
      </div> */}

      <span className={CssClasses.title}>{props.title}</span>
    </div>
  );
};

export default BetTypeButton;



// WEBPACK FOOTER //
// ./src/Components/UI/BetTypeButton/BetTypeButton.js